import React from 'react';
import { Subhead } from '../../../styled components/Typography';
import ListViewCard from './ListViewCard/ListViewCard';
import type {
  ListViewColumn,
  ListViewDiff,
  ListViewGroup,
  ListViewSetCollapse,
  TimeFormatSetting
} from '../../types';

/* Bookings without a date are grouped under a heading of their own */
function groupHeading(group: ListViewGroup): string | null {
  if (group.key === null) return i18n('No date');
  return group.dateObject ? group.dateObject.format('dddd LL') : group.label;
}

interface ListViewDayGroupProps {
  group: ListViewGroup;
  titleColumn: ListViewColumn;
  detailColumns: ListViewColumn[];
  setCollapse: ListViewSetCollapse;
  statusByID: ListViewDiff['statusByID'];
  now: string;
  dateFormatSetting: string;
  timeFormatSetting: TimeFormatSetting;
}

/* The bookings of one day, under a heading for that day */
const ListViewDayGroup = ({
  group,
  titleColumn,
  detailColumns,
  setCollapse,
  statusByID,
  now,
  dateFormatSetting,
  timeFormatSetting
}: ListViewDayGroupProps) => (
  <section tw="mb-16">
    <Subhead as="h2">{groupHeading(group)}</Subhead>
    <div tw="mt-8">
      {group.bookings.map((booking) => (
        <ListViewCard
          key={booking.id}
          booking={booking}
          titleColumn={titleColumn}
          detailColumns={detailColumns}
          setCollapse={setCollapse}
          statusByID={statusByID}
          now={now}
          dateFormatSetting={dateFormatSetting}
          timeFormatSetting={timeFormatSetting}
        />
      ))}
    </div>
  </section>
);

export default ListViewDayGroup;
